<template>
    <div>
        <UiComponentTypography tag="h5"> {{ filter }} </UiComponentTypography>
        <ul class="flex gap-4 mt-4">
            <li
                v-for="(item, index) in options"
                class="max-w-1/2 lg:max-w-1/4 rounded bg-gradient-to-t to-transparent cursor-pointer transition-all group border-b-2"
                :class="[
                    activeVariant === item.value
                        ? ' border-amazon-500 from-amazon-500/40 shadow-[0_2px_0] shadow-amazon-500'
                        : ' border-gray-500 from-gray-300/25 hover:from-gray-400/30',
                    deactivateIndexes?.includes(index) ? 'opacity-25' : '',
                ]"
                @click="changeActive(index)"
            >
                <div class="flex flex-col items-center pb-2 relative bottom-0 group-hover:bottom-1 transition-all">
                    <NuxtImg class="max-h-24 relative z-20" provider="backend" :src="getImageUrl(item.thumb)" />
                    <div
                        class="whitespace-nowrap text-xs rounded px-4 py-1"
                        :class="
                            activeVariant === item.value
                                ? 'bg-amazon-500 text-white'
                                : 'text-gray-500 border border-gray-400'
                        "
                    >
                        {{ item.value }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
const activeVariant = defineModel();

const emits = defineEmits(["update"]);

interface IWeightOptions {
    value: string;
    thumb?: string;
}

const props = defineProps({
    options: {
        type: Array as PropType<IWeightOptions[]>,
    },
    filter: {
        type: String,
        default: "",
    },
    deactivateIndexes: {
        type: Array,
    },
});

function changeActive(index: number) {
    emits("update", { [props.filter]: activeVariant.value }, { [props.filter]: props.options?.[index].value });
    activeVariant.value = props.options?.[index].value;
}
</script>

<style></style>
